import { NonQualifyingAdverb } from '../../types'

const заебись: NonQualifyingAdverb = {
  type: 'non qualifying adverb',
  adverb: 'заебись',
}

export default заебись
